import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { StateService } from '../../state/state.service';
import { Estimate } from '../../core/model/estimate';
import { Order } from '../../core/model/order';


@Component({
  selector: 'app-order-card',
  templateUrl: './order-card.component.html',
  styleUrls: ['./order-card.component.scss']
})
export class OrderCardComponent implements OnInit {
  @Input() estimate: Estimate;
  @Input() order: Order;

  imageSpinner: boolean;

  constructor(
    private state: StateService,
  ) { }

  ngOnInit(): void {
    this.imageSpinner = true;

    if (!this.estimate.imgUrls.length) {
      this.imageSpinner = false;
    }
  }

  checkUserType() {
    if (this.state.snapshot.auth.userPath === "lab") {
      return false;
    } else {
      return true;
    }
  }

  imageLoaded() {
    this.imageSpinner = false;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/order-card/order-card.component.ts